
<div  role="main">
  <div class="cit2-page-heading-container">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="cit2-page-heading">
            <div class="title">
              <div class="gb-headline1 my-5">{{'recallCenter_pageTitleText' | translate}}</div>
            </div>
            <ng-content select="vehicle-switcher" ngProjectAs="webu-vehicle-switcher"></ng-content>
          </div>
        </div>
        <div class="col-12 gb-body1">
          <webu-recalls-header></webu-recalls-header>
        </div>
      </div>
    </div>
  </div>
  <div class="container white-narrow-container">
    <div id="topOfForm" class="row pb-2 pb-lg-6 px-3 pt-6 px-lg-7 pt-lg-10">
      <div class="row"><!-- START: ALERT MESSAGES -->
        <div class="col-8">
          <ng-content select="main-content-errors"></ng-content>
        </div>
      </div><!-- END: ALERT MESSAGES -->
      
      <ng-content select="onstar-legal"></ng-content>
  
      <div class="col-12 col-md-8">
        <ng-content select="webu-warranty-mileage"></ng-content>
        <ng-content select="webu-recall-center-search-results"></ng-content>
      </div><!-- CLOSE col-12 col-sm-8 -->
      <div class="col-12 col-md-4">
        <ng-content select="webu-takata-stay-up-to-date"></ng-content>
        <ng-content select="webu-dealer-need-service"></ng-content>
        <ng-content select="create-account-widget"></ng-content>
      </div>
    </div><!-- CLOSE row -->
  </div><!-- CLOSE container -->
</div>


